module.exports = __webpack_public_path__ + "static/media/profile-volksbank.5630728f.webp";